export default __webpack_public_path__ + "static/mint-chip-2c4a2818f88e415abff564fafa3d6ac9.png";